import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import SanityLink from '@/lib/SanityLink'

const FooterBottom = () => {
	const { site, footer } = useStaticQuery(query)

	return (
		<div className="flex flex-wrap <md:flex-col gap-y-4 gap-x-8 md:items-end text-sm">
			<div className='flex-grow'>
				<address>{site.address}</address>
				<p>
					Phone: <a className="link" href={`tel:${site.phone}`}>{site.phone}</a>
					{' / '}
					Email: <a className="link" href={`mailto:${site.email}`}>{site.email}</a>
				</p>
				<p>{footer.bottomText}</p>
			</div>

			<p className="text-center">
				{site.title} &copy; {new Date().getFullYear()} All rights reserved.
			</p>

			<ul className="flex flex-wrap <md:flex-col items-center gap-x-8">
				{footer.bottomLinks?.map((link, key) => (
					<li key={key}>
						<SanityLink className="opacity-60 hover:underline" {...link} />
					</li>
				))}
			</ul>
		</div>
	)
}

export default FooterBottom

export const query = graphql`query FooterBottom {
	site: sanitySite {
		title
		phone
		email
		address
	}
	footer: sanityFooter {
		bottomText
		bottomLinks { ...link }
	}
}`
